import {compose} from 'redux';
import withUsers from '../../../_common/components/Users/components/withUsers';
import TasksFilters from './TasksFilters';

export default compose(
  withUsers
)(TasksFilters);
